<template>
  <div>
    <div class="top">
    <div style="height:120px;"></div>
      <div class="ioGvTH">
        <div class="sc-gKclnd">
          <div class="go-to-register" @click="()=>{this.$router.push({ name: 'Register' })}"><span class="zc">注册</span></div>
          <div class="ms-title">
            <div style="text-align: center;width: 50%;">
              <span class="tils">账号登录</span>
              <el-form :model="param"  ref="login" label-width="0px" class="ms-content">
                <el-form-item prop="username" label="登录账号：" label-width="180">
                    <el-input v-model="param.username" placeholder="username">
                    </el-input>
                </el-form-item>
                <el-form-item prop="password" label="登录密码：" label-width="180">
                    <el-input type="password" placeholder="password" v-model="param.password"
                        @keyup.enter="submitForm(login)">
                    </el-input>
                </el-form-item>
                <div class="login-btn">
                    <el-button type="primary" style="width: 100%;" @click="submitForm(login)">登录</el-button>
                </div>
            </el-form>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div style="height: 120px; width: 1920px;background-color: #fafafc;"></div>
  </div>
</template>
<script>
export default {
    name: 'Login',
    data () {
        return {
          param:{

          }
        }
    },
    methods: {
    },
    mounted () {
    }
}
</script>

<style scoped>
.top {
    margin-top: 120px;   
    margin-bottom: 77px;
    display: flex;
    justify-content: center;
}
.tils{
  display: inline-block;
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 51px
}
.ms-title{
  margin-top: 15%;
  display:flex;
  justify-content: center;
}
.go-to-register{
  cursor: pointer;
    height: 70px;
    width: 70px;
    background-image: url("https://img.alicdn.com/imgextra/i3/O1CN01yz6fEl1MwaRtkJyvf_!!6000000001499-55-tps-70-70.svg");
    position: absolute;
    top: 0px;
    right: 0px;
    text-align: right;
}
.zc{
    position: relative;
    top:12px;
    left:-4px;
}
.sc-gKclnd{
    width: 700px;
    background-color: rgb(255, 255, 255);
    height: 600px;
    overflow: hidden;
    position: relative;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 15px;
}
</style>